import React from 'react';
import { Tooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import { INK } from '../monitoringTheme';

/**
 * Icône d'aide accessible au clavier (m-10) : focusable, l'infobulle s'ouvre
 * au survol comme au focus, et le texte est exposé aux lecteurs d'écran.
 */
const HelpIcon: React.FC<{ text: string }> = ({ text }) => (
    <Tooltip title={text} trigger={['hover', 'focus']}>
        <span
            role="img"
            tabIndex={0}
            aria-label={text}
            style={{ color: INK.muted, fontSize: 12, display: 'inline-flex', cursor: 'help', borderRadius: 4 }}
        >
            <InfoCircleOutlined aria-hidden />
        </span>
    </Tooltip>
);

export default HelpIcon;
